<style>
    table, th, td{
         border: solid 1px rgba(40,40,40,0.2);
         font-size:14px;
         padding:5px;
     }
     table{
         width: 100%;
     }
 </style>
    <div class="col-12">
        <h2>Fundas Aluminizadas</h2>
    </div>
    <div class="col-12">
        <table id="myTable">
            <tr class="header">
              <th style="width:40%;"><t1>Artículo</t1></th>
              <th style="width:10%;"><t1>Código</t1></th>
              <th style="width:10%;"><t1>Espesor</t1></th>
              <th style="width:10%;"><t1>Ancho</t1></th>
              <th style="width:30%;"><t1>Tamaño de Rollo</t1></th>
            </tr>
            <tr>
              <td><t2>Espuma 3mm</t2></td>
              <td><t2>E001</t2></td>
              <td><t2>3.00 mm</t2></td>
              <td><t2>1 m</t2></td>
              <td><t2>20 m</t2></td>
            </tr>
            <tr>
                <td><t2>Espuma 5mm</t2></td>
                <td><t2>E002</t2></td>
                <td><t2>5.00 mm</t2></td>
                <td><t2>1 m</t2></td>
                <td><t2>20 m</t2></td>
              </tr>
          </table>
    </div>
